import React from "react";
import { getFileIcon } from "../../../../Helpers/fileIcon";
import styles from "../DocumentViewer.module.css";

type UnsupportedFallbackProps = {
  fileName: string;
  onDownload?: () => void;
};

const UnsupportedFallback = ({ fileName, onDownload }: UnsupportedFallbackProps) => (
  <div className={styles.fallback}>
    <img className={styles.fallbackIcon} src={getFileIcon(fileName)} alt="" />
    <p className={styles.fallbackTitle}>{fileName}</p>
    <p className={styles.fallbackCopy}>Preview isn’t available for this file type.</p>
    {onDownload && (
      <button type="button" className={styles.toolbarButton} onClick={onDownload}>
        Download
      </button>
    )}
  </div>
);

export default UnsupportedFallback;
